import React from 'react'

const SVG = ({
  style = {},
  fill = '#5F5F5F',
  width = '100%',
  className = '',
  viewBox = '0 0 23 23'
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <path
      fill={fill}
      d='M22.7,21.4l-6.6-6.5h-1c3.4-3.5,3.2-9.1-0.3-12.4c-3.4-3.4-9-3.3-12.4,0.2s-3.2,9.1,0.3,12.4
	c3.4,3.2,8.7,3.3,12.1,0.1v1l6.6,6.5c0.4,0.4,1,0.4,1.3,0C23.1,22.4,23.1,21.8,22.7,21.4L22.7,21.4L22.7,21.4z M8.8,15.6
	C5,15.6,2,12.5,2,8.8S5.1,2,8.8,2c3.8,0,6.8,3,6.8,6.8C15.7,12.6,12.6,15.6,8.8,15.6z'
    />
  </svg>
)

export default SVG
